import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

// Desktop Table Styles
export const TableContainer = styled.div`
  width: 100%;
`;

export const TableHeader = styled.div`
  padding: 0 24px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(249, 250, 251, 0.8);
`;

export const HeaderActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const SearchContainer = styled.div`
  flex: 1;
  max-width: 400px;
  
  .ant-input-affix-wrapper {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    
    &:hover, &:focus {
      border-color: #1677ff;
      box-shadow: 0 2px 8px rgba(22, 119, 255, 0.15);
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;


export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  background: rgba(249, 250, 251, 0.5);
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  transition: background-color 0.2s ease;
  
  &:hover {
    background: rgba(22, 119, 255, 0.02);
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 2px solid rgba(0, 0, 0, 0.06);
  
  &:first-child {
    width: 48px;
    padding-left: 24px;
  }
  
  &:last-child {
    width: 120px;
    padding-right: 24px;
  }
`;

export const TableCell = styled.td`
  padding: 16px 12px;
  vertical-align: middle;
  
  &:first-child {
    padding-left: 24px;
  }
  
  &:last-child {
    padding-right: 24px;
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.15);
  cursor: pointer;
  
  &:checked {
    background: #1677ff;
    border-color: #1677ff;
  }
`;

export const StudentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StudentAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }
`;

export const StudentDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StudentName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
`;

export const StudentId = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  
  .anticon {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
  }
`;

export const GradeBadge = styled.div<{ grade: number }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  
  ${({ grade }) => {
    if (grade >= 8) return `
      background: rgba(82, 196, 26, 0.1);
      color: #52c41a;
      border: 1px solid rgba(82, 196, 26, 0.2);
    `;
    if (grade >= 6) return `
      background: rgba(250, 173, 20, 0.1);
      color: #faad14;
      border: 1px solid rgba(250, 173, 20, 0.2);
    `;
    if (grade >= 4) return `
      background: rgba(255, 77, 79, 0.1);
      color: #ff4d4f;
      border: 1px solid rgba(255, 77, 79, 0.2);
    `;
    return `
      background: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.45);
      border: 1px solid rgba(0, 0, 0, 0.06);
    `;
  }}
`;

export const AttendanceBadge = styled.div<{ attendance: number }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  
  ${({ attendance }) => {
    if (attendance >= 90) return `
      background: rgba(82, 196, 26, 0.1);
      color: #52c41a;
      border: 1px solid rgba(82, 196, 26, 0.2);
    `;
    if (attendance >= 75) return `
      background: rgba(250, 173, 20, 0.1);
      color: #faad14;
      border: 1px solid rgba(250, 173, 20, 0.2);
    `;
    if (attendance >= 50) return `
      background: rgba(255, 77, 79, 0.1);
      color: #ff4d4f;
      border: 1px solid rgba(255, 77, 79, 0.2);
    `;
    return `
      background: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.45);
      border: 1px solid rgba(0, 0, 0, 0.06);
    `;
  }}
`;

export const LastActivity = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionButton = styled.button<{ danger?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  .anticon {
    font-size: 14px;
    color: ${({ danger }) => danger ? '#ff4d4f' : 'rgba(0, 0, 0, 0.65)'};
  }
  
  &:hover {
    border-color: ${({ danger }) => danger ? '#ff4d4f' : '#1677ff'};
    background: ${({ danger }) => danger ? 'rgba(255, 77, 79, 0.04)' : 'rgba(22, 119, 255, 0.04)'};
  }
`;

// Mobile Styles
export const MobileContainer = styled.div`
  width: 100%;
`;

export const MobileHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(249, 250, 251, 0.8);
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MobileActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobileActionButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  .anticon {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
  }
  
  &:hover {
    border-color: #1677ff;
    background: rgba(22, 119, 255, 0.04);
    
    .anticon {
      color: #1677ff;
    }
  }
`;

export const CardsContainer = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StudentCard = styled.div`
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: rgba(22, 119, 255, 0.2);
    box-shadow: 0 4px 12px rgba(22, 119, 255, 0.08);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StatLabel = styled.div`
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

export const LastActivityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 4px;
  
  .anticon {
    font-size: 12px;
  }
`;

// Empty State
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  
  .anticon {
    font-size: 48px;
    color: rgba(0, 0, 0, 0.25);
    margin-bottom: 16px;
  }
  
  h3 {
    margin: 0 0 8px 0;
    font-size: 18px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  
  p {
    margin: 0 0 24px 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    max-width: 300px;
  }
`;

// Empty value placeholder
export const EmptyValue = styled.span`
  color: rgba(0, 0, 0, 0.25);
`;
